import React, { useState } from "react";
import { Container, Card, Form, Button, Alert, InputGroup } from "react-bootstrap";
import AppContext from "../../../AppContext";
import { useSelector } from "react-redux";
import PanelLayout from "../../../layouts/PanelLayout";

function Configuracion() {
  const usuario = useSelector((state) => state.usuario);
  const mailAutenticado = usuario?.mail || localStorage.getItem("mail") || "";

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const changePasswordUrl = `${AppContext.baseApiUrl}${AppContext.urlServiceChangePassword}`;

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!mailAutenticado) {
      setError("Usuario no autenticado.");
      return;
    }

    if (!currentPassword || !newPassword || !confirmPassword) {
      setError("Todos los campos son obligatorios.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("Las contraseñas nuevas no coinciden.");
      return;
    }

    if (newPassword.length < 6) {
      setError("La nueva contraseña debe tener al menos 6 caracteres.");
      return;
    }

    try {
      const response = await fetch(changePasswordUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          mail: mailAutenticado,
          clave: currentPassword,
          nuevaClave: newPassword,
        }),
      });

      const data = await response.text();

      if (!response.ok) {
        throw new Error(data || "Error al cambiar contraseña.");
      }

      setSuccess("Contraseña cambiada correctamente.");
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <PanelLayout>
      <Container className="py-5">
        <Card className="shadow-lg rounded-4">
          <Card.Header className="fw-bold">Configuración de cuenta</Card.Header>
          <Card.Body>
            <h6 className="mb-3">Cambiar contraseña</h6>

            {error && <Alert variant="danger">{error}</Alert>}
            {success && <Alert variant="success">{success}</Alert>}

            <Form onSubmit={handleChangePassword}>
              <Form.Group className="mb-3">
                <Form.Label>Contraseña actual</Form.Label>
                <InputGroup>
                  <Form.Control
                    type={showCurrent ? "text" : "password"}
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                  />
                  <Button
                    variant="outline-secondary"
                    onClick={() => setShowCurrent(!showCurrent)}
                  >
                    👁
                  </Button>
                </InputGroup>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Nueva contraseña</Form.Label>
                <InputGroup>
                  <Form.Control
                    type={showNew ? "text" : "password"}
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                  <Button
                    variant="outline-secondary"
                    onClick={() => setShowNew(!showNew)}
                  >
                    👁
                  </Button>
                </InputGroup>
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>Confirmar nueva contraseña</Form.Label>
                <InputGroup>
                  <Form.Control
                    type={showConfirm ? "text" : "password"}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                  <Button
                    variant="outline-secondary"
                    onClick={() => setShowConfirm(!showConfirm)}
                  >
                    👁
                  </Button>
                </InputGroup>
              </Form.Group>

              <Button type="submit" variant="success" className="rounded-pill px-4">
                Guardar cambios
              </Button>
            </Form>
          </Card.Body>
        </Card>
      </Container>
    </PanelLayout>
  );
}

export default Configuracion;
